import { createReducer } from "@reduxjs/toolkit";
import { resetToggleBatchPublicVisibility, toggleBatchPublicVisibility } from "./toggle-batch-public-visibility";
import type { ProcessingState } from "@redux/state/shared-types";

const initialState: ProcessingState = { processing: "idle" };

export const toggleBatchPublicVisibilityReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(toggleBatchPublicVisibility.fulfilled, state => {
    return { ...state, processing: "success" };
  });
  builder.addCase(toggleBatchPublicVisibility.pending, state => {
    return { ...state, processing: "pending" };
  });
  builder.addCase(toggleBatchPublicVisibility.rejected, state => {
    return { ...state, processing: "failed" };
  });
  builder.addCase(resetToggleBatchPublicVisibility, () => {
    return initialState;
  });
});
